export default __webpack_public_path__ + "static/realtime-consultation-5f1befb98b4e6245cf72d56371974bcf.png";